import React from "react";
import ProductItem from "../ProductItem/ProductItem";
import Title from "../Title/Title";

const ListProducts = ({ listProducts, segmentFlag, deleteProduct, onEditProduct }) => {
  const productItem = (product) => <ProductItem
    key={product.codigo}
    product={product}
    onEdit={onEditProduct}
    deleteProduct={deleteProduct}
  />

    const groupedProducts = () => (
      <div style={{paddingTop: 10}}>
          {Object.keys(listProducts)?.map((category) => (
            <div key={category}>
                <Title style={{color: 'white'}}>{category}</Title>

                {listProducts[category]?.map((product) => productItem(product))}
            </div>
          ))}
      </div>
    );

    const normalList = () => (
      <div>
          {listProducts?.map((product) => productItem(product))}
      </div>
    )

    return segmentFlag ? groupedProducts() : normalList();
};

export default ListProducts;
